import idx from 'idx';

import { NAME } from './constants';

export const countriesFetching = state =>
  idx(state, p => p[NAME].countries.isFetching);

export const getCountries = state => idx(state, p => p[NAME].countries.data);
